// Single timeout duration (ms) for a checkout attempt, centralized so its uses
// stay on the same value. The pay flow applies it as handlePaymentAttempt's UI
// timeout and, when that fires, aborts the AbortSignal it passes to
// checkOutWithStripe — so the fetch is cancelled by the same timeout.
// checkOutWithStripe also uses this value for its own fallback timeout when
// called without a signal. (The UI timer and any fallback fetch timer start at
// different points, so they may still fire at slightly different moments; the
// point is they share one duration.) A hung/slow backend must never leave the
// pay button stuck on "Processing..." indefinitely.
export const CHECKOUT_TIMEOUT_MS = 30000 as const

// Hard cap (ms) for recording a vote/submission (addVote). Without it a hung
// persist call leaves submissionIsProcessing stuck true — blocking the wizard
// close button and, in the paid flow, hanging handlePaymentAttempt's
// castSubmission() await before it can reset the "Processing..." state.
export const SUBMISSION_TIMEOUT_MS = 30000 as const
